module.exports = __webpack_public_path__ + "img/autosense-product-page.1ead03b1.png";